import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Header = ({ onOpenAppointment }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: "/", name: "Home" },
    { path: "/services", name: "Services" },
    { path: "/blog", name: "Blog" },
    { path: "/about", name: "About Us" },
    { path: "/contact", name: "Contact" }
  ];

  return (
    <>
      <header className={`bg-white/95 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-100 shadow-xs transition-all duration-300 ${isScrolled ? 'py-2' : 'py-3'}`}>
        <div className="container mx-auto px-5 flex justify-between items-center">
          <div className="flex items-center group">
            <div className="p-1 rounded-lg group-hover:bg-indigo-50 transition-colors duration-300">
              <img
                src="/logo.webp"
                alt="Hospital Logo"
                className="h-11 w-11 mr-3 transition-all duration-400 group-hover:rotate-[8deg]"
              />

            </div>
            <Link
              to="/"
              className="text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500 hover:from-indigo-700 hover:to-cyan-600 transition-all duration-500 hover:tracking-wide"
            >
              The Healing
            </Link>
          </div>

          <nav className="hidden md:flex space-x-4">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="relative px-3 py-2 text-gray-600 hover:text-indigo-600 font-medium transition-all duration-300 group"
              >
                <span className="relative z-10">
                  {item.name}
                </span>
                <span className="absolute left-0 right-0 -bottom-1 h-0.5 bg-gradient-to-r from-indigo-400 to-cyan-400 origin-left transform scale-x-0 group-hover:scale-x-100 transition-transform duration-400 ease-out"></span>
              </Link>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <button
              onClick={onOpenAppointment}
              className="hidden sm:inline-flex relative overflow-hidden group bg-gradient-to-r from-indigo-600 to-cyan-500 text-white px-6 py-2.5 rounded-lg shadow-sm hover:shadow-md transition-all duration-400"
            >
              <span className="relative z-10 inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Book Appointment
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-indigo-700 to-cyan-600 opacity-0 group-hover:opacity-100 transition-opacity duration-400"></span>
            </button>

            <button
              className="md:hidden p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors duration-300"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
              </svg>
            </button>
          </div>
        </div>
      </header>

      <div className={`fixed inset-0 z-40 bg-black/50 backdrop-blur-sm transition-opacity duration-300 md:hidden ${isMobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        onClick={closeMobileMenu}
      ></div>

      <div className={`fixed top-0 right-0 z-50 h-full w-64 bg-white shadow-xl transition-transform duration-300 ease-in-out md:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex flex-col h-full p-5">
          <div className="flex justify-between items-center mb-8">
            <div className="flex items-center group">
              <div className="p-1 rounded-lg group-hover:bg-indigo-50 transition-colors duration-300">
                <img
                  src="/logo.webp"
                  alt="Hospital Logo"
                  className="h-10 w-10 mr-2 transition-all duration-400 group-hover:rotate-[8deg]"
                />

              </div>
              <span className="text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-cyan-500">
                The Healing
              </span>
            </div>
            <button
              className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300"
              onClick={closeMobileMenu}
              aria-label="Close menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <nav className="flex-1 flex flex-col space-y-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="px-4 py-3 text-gray-700 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg font-medium transition-all duration-300"
                onClick={closeMobileMenu}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          <div className="pt-4 border-t border-gray-100">
            <button
              onClick={() => {
                onOpenAppointment();
                closeMobileMenu();
              }}
              className="w-full bg-gradient-to-r from-indigo-600 to-cyan-500 text-white px-6 py-3 rounded-lg shadow-sm hover:shadow-md transition-all duration-400 flex items-center justify-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Book Appointment
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;